export enum UpvestAccountStatuses {
    pending_approval="PENDING_APPROVAL",
    active="ACTIVE",
    closing="CLOSING",
    closed="CLOSED",
    locked="LOCKED"
}